import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@exiftrator/shared/components/ui';

function DeleteConfirmDialog({
  open,
  onOpenChange,
  itemLabel,
  title = 'Delete item',
  description,
  onConfirm,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
}) {
  const resolvedDescription =
    description ||
    (itemLabel
      ? `Are you sure you want to delete "${itemLabel}"? This action cannot be undone.`
      : 'Are you sure you want to delete this item? This action cannot be undone.');

  const handleConfirm = () => {
    onConfirm?.();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md border-border-default bg-bg-secondary">
        <DialogHeader className="text-left">
          <DialogTitle className="text-base text-text-primary">{title}</DialogTitle>
          <DialogDescription className="text-sm text-text-supporting">
            {resolvedDescription}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:justify-end">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            {cancelLabel}
          </Button>
          <Button type="button" variant="destructive" onClick={handleConfirm}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DeleteConfirmDialog;
